/* assets/localization.js
   Safe initialization for <localization-form>.
   - Registers custom element only once
   - Guards against missing DOM nodes
   - Observes document.body for dynamically injected markup
*/
(function () {
  'use strict';

  function defineLocalizationForm() {
    if (customElements && customElements.get && customElements.get('localization-form')) return;

    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[name="language_code"], input[name="country_code"]');
        this.button = this.querySelector('button');
        this.panel = this.querySelector('ul');

        // If any of the core pieces are missing, stop (prevents errors)
        if (!this.button) return;

        this._onButtonClick = this.openSelector.bind(this);
        this._onButtonFocusOut = this.closeSelector.bind(this);
        this._onKeyUp = this.onContainerKeyUp.bind(this);
        this._onItemClick = this.onItemClick.bind(this);

        this.button.addEventListener('click', this._onButtonClick);
        this.button.addEventListener('focusout', this._onButtonFocusOut);
        this.addEventListener('keyup', this._onKeyUp);
        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this._onItemClick));
      }

      hidePanel() {
        if (!this.button || !this.panel) return;
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event && event.code && event.code.toUpperCase() === 'ESCAPE') {
          this.hidePanel();
          if (this.button) this.button.focus();
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        if (this.input) this.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        if (!this.button || !this.panel) return;
        const isHidden = this.panel.hasAttribute('hidden');
        if (isHidden) {
          this.panel.removeAttribute('hidden');
          this.button.setAttribute('aria-expanded', 'true');
        } else {
          this.panel.setAttribute('hidden', true);
          this.button.setAttribute('aria-expanded', 'false');
        }
      }

      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
          this.hidePanel();
        }
      }
    }

    try {
      if (!customElements.get('localization-form')) {
        customElements.define('localization-form', LocalizationForm);
      }
      // flag so repeated loads won't re-define
      window.__localizationFormDefined = true;
    } catch (err) {
      // Defensive: if define fails (already defined) => ignore
      // eslint-disable-next-line no-console
      console.warn('localization-form not registered (already exists?):', err);
    }
  }

  function init() {
    defineLocalizationForm();

    // If no localization-form in DOM yet, watch document.body for it being injected.
    // Observe document.body only (never null).
    if (!document.querySelector('localization-form')) {
      if (document.body) {
        var observer = new MutationObserver(function (mutations, obs) {
          if (document.querySelector('localization-form')) {
            defineLocalizationForm();
            obs.disconnect();
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        // fallback
        document.addEventListener('DOMContentLoaded', function () {
          if (document.querySelector('localization-form')) defineLocalizationForm();
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
